<template>
    <b-row class="mh-datarow" :class="{'mini': mini}">
        <b-col cols="3" class="column title">
            <i class="far mr-2" :class="icon" v-if="icon"></i><strong>{{title}}</strong>
        </b-col>
        <b-col class="column">
            <slot/>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "DataRow",
        props: {
            title: String,
            icon: String,
            mini: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    .mh-datarow {
        color: #46697c;
        font-size: 0.85rem;

        border-bottom: 1px solid #efefef;
        padding: 0 1.2rem;

        .title {
            border-right: 1px solid #efefef;
        }

        .column {
            padding: 0.3rem 0.3rem 0.3rem 1.2rem;
        }

        &.mini {
            font-size: 0.7rem;
            padding: 0;
            margin: 0;

            .column {
                padding: 0.2rem 0.4rem;
            }
        }

        &:last-child {
            border: 0;
        }
    }
</style>
